import React from "react";
import {
	Chart as ChartJS,
	BarElement,
	CategoryScale,
	LinearScale,
	Tooltip,
	Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const BarChart = ({
	title,
	labels,
	datasets,
	height = 300,
}) => {

	// ✔ Only keep these 2 colors (no blue, no pink)
	const ARGON_COLORS = [
		"rgba(130, 94, 228, 0.9)",   // Argon Purple
		"rgba(251, 99, 64, 0.9)",    // Argon Orange
	];

	// ✔ Always force these colors
	const updatedDatasets = datasets.map((ds, i) => ({
		...ds,
		backgroundColor: ARGON_COLORS[i % ARGON_COLORS.length],
		hoverBackgroundColor: ARGON_COLORS[i % ARGON_COLORS.length],
		borderColor: "transparent",
		borderRadius: 8,
	}));

	const data = {
		labels,
		datasets: updatedDatasets,
	};

	const options = {
		responsive: true,
		maintainAspectRatio: false,

		plugins: {
			legend: {
				position: "bottom",
				labels: {
					boxWidth: 12,
					boxHeight: 12,
					padding: 14,
					font: { size: 11 },
					color: "#475569",
				},
			},
			tooltip: {
				backgroundColor: "#ffffff",
				titleColor: "#000",
				bodyColor: "#000",
				borderColor: "#e2e8f0",
				borderWidth: 1,
				cornerRadius: 8,
				padding: 10,
				displayColors: false,
			},
			datalabels: {
				display: false, // hide numbers on graph
			},
		},

		scales: {
			x: {
				ticks: {
					color: "#1e293b",
					font: { size: 11 },
				},
				grid: { display: false },
				border: { color: "#cbd5e1" },
			},
			y: {
				ticks: {
					color: "#1e293b",
					font: { size: 11 },
				},
				grid: {
					color: "rgba(226, 232, 240, 0.6)",
					lineWidth: 1,
				},
				border: { color: "#cbd5e1" },
			},
		},
	};

	return (
		<div className="bg-white rounded-xl shadow-md p-4">
			<h3 className="text-sm font-semibold text-slate-700 mb-3">{title}</h3>

			<div style={{ height }}>
				<Bar data={data} options={options} />
			</div>
		</div>
	);
};

export default BarChart;
